import { VRGL_HOUSEHOLD } from '../constants';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class VRGLIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getVRGLIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.VRGL_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getVRGLHouseholdSearchResults(searchTerms, page) {
        const urlParams = { searchType: VRGL_HOUSEHOLD };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.VRGL_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getVRGLHouseholdAccounts(householdId, page) {
        const urlParams = { householdId };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.VRGL_HOUSEHOLD_ACCOUNTS, urlParams)}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getVRGLHouseholdProposalAccounts(householdId, page) {
        const urlParams = { householdId };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.VRGL_HOUSEHOLD_PROPOSAL_ACCOUNTS, urlParams)}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getVRGLResourceSearchResults(searchTerms, page, searchType) {
        const urlParams = { searchType };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.VRGL_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importVRGLHoldings(importType, postParams) {
        const urlParams = { importType };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.VRGL_IMPORT_HOLDINGS, urlParams)}`;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    importVRGLProposalAccountHoldings(importType, postParams) {
        const urlParams = { importType };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.VRGL_IMPORT_HOLDINGS, urlParams)}`;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    importVRGLResourceHoldings(importType, postParams) {
        const urlParams = { importType };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.VRGL_IMPORT_HOLDINGS, urlParams)}`;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    sendVRGLRequestEmail(firmName, vrglAccountEmail) {
        const url = this.urlsService.INTEGRATIONS.VRGL_SEND_REQUEST_EMAIL;
        return this.ajaxService.postJsonDataObserveResponse(url, { firmName, vrglAccountEmail });
    }
}
VRGLIntegrationService.ɵfac = function VRGLIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || VRGLIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
VRGLIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: VRGLIntegrationService, factory: VRGLIntegrationService.ɵfac, providedIn: 'root' });
